export default __webpack_public_path__ + "static/media/owner.8b1497b5.svg";